import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import HomePage from './pages/HomePage'; 
import Sobre from './pages/Sobre';
import Cursos from './pages/Cursos';
import Servicos from './pages/Servicos';  
import Equipamentos from './pages/Equipamentos'; 
import Estrutura from './pages/Estrutura'; 
import Equipe from './pages/Equipe';
import PoliticaPrivacidade from './pages/Politicas';
import TermosCondicoes from './pages/Termos';
import ScrollToTop from "./components/ScrollToTop";
import ParallaxManager from "./components/ParallaxManager";
import usePageTracking from "./hooks/usePageTracking"; // <-- import

// Componente que executa o tracking DENTRO do Router
function RouteChangeTracker() {
  usePageTracking("G-FJJJLZ7ZM0"); // GA4 ID
  return null; // não renderiza nada na tela
}

function App() {
  return (
    <BrowserRouter>
      <ParallaxManager />
      <ScrollToTop />
      <RouteChangeTracker />  {/* <-- agora o hook roda dentro do Router */}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/cursos" element={<Cursos />} />
        <Route path="/servicos" element={<Servicos />} />
        <Route path="/equipamentos" element={<Equipamentos />} />
        <Route path="/estrutura" element={<Estrutura />} />
        <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
        <Route path="/equipe" element={<Equipe />} />
        <Route path="/termos-e-condicoes" element={<TermosCondicoes />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
